import {useReducer} from "react";

import * as api from "../../services/api";
import {useFeedbackTools} from "../../components/FeedbackTools";


const useEmailMessage = () => {

    // A reducer that keep track of the loading status and the resend status
    const [state, dispatcher] = useReducer(
        (state, action) => {
            switch (action.type) {
                case 'setAttributes':
                    return {...state, ...action.attributes}
                default:
                    throw new Error(`Cannot find action ${action.type} for useEmailMessage reducer`);
            }
        },
        {
            isResendingEmail: false,
            isLoadingEmail: true,
        }
    );
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const loadEmailMessage = async (emailMessageId) => {
        try {
            dispatcher({type: "setAttributes", attributes: {isLoadingEmail: true}});
            const emailMessage = await api.Templates.getEmailMessage(emailMessageId);
            dispatcher({type: "setAttributes", attributes: {isLoadingEmail: false, emailMessage: emailMessage}});
        } catch (e) {
            showErrorNotification(e);
            dispatcher({type: "setAttributes", attributes: {isLoadingEmail: false}});
        }
    }

    const resendEmailMessage = async (emailMessageId, onSuccess=f=>f) => {
        try{
            dispatcher({type: "setAttributes", attributes: {isResendingEmail: true}});
            const emailMessage = await api.Templates.resendEmailMessage(emailMessageId);
            onSuccess(emailMessage);
            dispatcher({type: "setAttributes", attributes: {isResendingEmail: false}});
            showSuccessNotification("Invio email in corso...");
        }catch (e) {
            showErrorNotification(e);
            dispatcher({type: "setAttributes", attributes: {isResendingEmail: false}});
        }
    }

    return {
        ...state,
        loadEmailMessage,
        resendEmailMessage
    }
}

export default useEmailMessage;